import React from 'react';
import { motion } from 'framer-motion';

interface ClueBoardProps {
  clues: string[];
  secretWord: string;
  discoveredLetters: Set<string>;
}

export const ClueBoard: React.FC<ClueBoardProps> = ({
  clues,
  secretWord,
  discoveredLetters
}) => {
  return (
    <div className="bg-white/20 rounded-2xl p-6">
      <h3 className="text-2xl font-bold mb-4">Detective's Notes</h3>
      
      <div className="space-y-4">
        <div className="flex justify-center space-x-2">
          {secretWord.split('').map((letter, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center text-2xl font-bold"
            >
              {discoveredLetters.has(letter) ? letter : '?'}
            </motion.div>
          ))}
        </div>

        <div className="space-y-2">
          {clues.map((clue, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.2 }}
              className="bg-white/10 p-3 rounded-lg"
            >
              {clue}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};